import { Component, inject, Input } from '@angular/core';
import {
  IonBreadcrumb,
  IonBreadcrumbs,
  IonHeader,
  IonLabel,
  IonSegment,
  IonSegmentButton,
  IonToolbar,
} from '@ionic/angular/standalone';

import { NavController } from '@ionic/angular';
import { HomePage } from '../../pages/home/home.page';
import { Company } from '../../apis/company.api';

export type GlobalPageHeaderComponentMenuItem = {
  name: string;
  uri: string;
};

@Component({
  selector: 'app-global-page-header',
  templateUrl: './global-page-header.component.html',
  styleUrls: ['./global-page-header.component.scss'],
  standalone: true,
  imports: [
    IonHeader,
    IonLabel,
    IonSegment,
    IonSegmentButton,
    IonToolbar,
    IonBreadcrumbs,
    IonBreadcrumb,
  ],
})
export class GlobalPageHeaderComponent {
  navController = inject(NavController);
  homePage = inject(HomePage, { optional: true });

  @Input() title: string | null = null;
  @Input() menu: GlobalPageHeaderComponentMenuItem[] | null = null;
  @Input() showBreadcum: boolean = false;

  constructor() {}

  onSegmentChange(event: any) {
    const selectedValue = event.detail.value;

    if (this.menu) {
      const route = this.menu.find(
        (item: GlobalPageHeaderComponentMenuItem) => item.uri === selectedValue,
      );

      if (route) {
        this.goTo(route.uri);
      }
    }
  }

  getCurrentSegment(): string {
    const currentUrl = document.location.href;

    if (this.menu) {
      for (let i = 0; i < this.menu.length; i++) {
        if (currentUrl.includes(this.menu[i].uri)) {
          return this.menu[i].uri;
        }
      }
    }

    return '';
  }

  goTo(uri: string) {
    this.navController.navigateRoot(uri);
  }

  goToCompany(company: Company) {
    const currentUrl = window.location.pathname;
    const newUrl = currentUrl.replace(
      `/${this.homePage?.currentOrganisationId}/`,
      `/${company.id}/`,
    );
    this.navController.navigateRoot(newUrl);
  }
}
